import { useDispatch, useSelector } from "react-redux"
import RenderBoiFields from "./RenderBoiFields"
import { BOI_FORM_STEPS } from "../../constants"
import { componentKey as fileBoiComponentKey, setHelpTextObj, setShowHelpPopup, updateBoiFormFields } from "../FileBoiSlice"
import { getCompanyApplicants, onDependentFieldChangeGetValues } from "../FileBoiSaga"
import { useEffect } from "react"

export default function CompanyApplications(){
    const { boiFormFields, onDependentFields, formsPreLoadedData, reportingCompanyDetailId, selectedCompanyApplicantIds } = useSelector(state => state[fileBoiComponentKey])
    const dispatch = useDispatch();

    useEffect(() => {
        if(reportingCompanyDetailId){
            dispatch(getCompanyApplicants({PayerDetailId: reportingCompanyDetailId, selectedCompanyApplicantIds: selectedCompanyApplicantIds}))
        }
    }, [reportingCompanyDetailId])

    return <>
        <RenderBoiFields stepFields={boiFormFields[BOI_FORM_STEPS.COMPANY_APPLICATION] ?? []} updateFormFieldsCb={(updatedFieldsList) => dispatch(updateBoiFormFields({[BOI_FORM_STEPS.COMPANY_APPLICATION]: updatedFieldsList}))} onDependentFieldChangeGetValuesCb={(onDependentFieldChangeData) => dispatch(onDependentFieldChangeGetValues(onDependentFieldChangeData))} currentStep={BOI_FORM_STEPS.COMPANY_APPLICATION} onDependentFields={onDependentFields} formsPreLoadedData={formsPreLoadedData} setShowHelpPopupCb={() => dispatch(setShowHelpPopup(true))} setHelpTextObjCb={(helpText) => dispatch(setHelpTextObj(helpText))} />
    </>
}